// extracted by mini-css-extract-plugin
export var label = "FormInputField-module--label--wThIb";
export var textarea = "FormInputField-module--textarea--87WGN";
export var input = "FormInputField-module--input--v4Na7";
export var formField = "FormInputField-module--formField--TJQvY";
export var fieldRequired = "FormInputField-module--fieldRequired--dA9po";
export var note = "FormInputField-module--note--g76Tv";